export default __webpack_public_path__ + "static/media/Level_one.51d03ef4.svg";